import { RelocationOrderStatus } from "@/api-schema-enums";

export const RELOCATION_ORDER_TERMINAL_STATUSES: readonly RelocationOrderStatus[] = [
  RelocationOrderStatus.Completed,
  RelocationOrderStatus.Cancelled,
];

export function isRelocationOrderTerminalStatus(status: RelocationOrderStatus | null | undefined): boolean {
  return !!status && RELOCATION_ORDER_TERMINAL_STATUSES.includes(status);
}
